var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorfulCheckInCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.18001L8.59 14.6L4.35 10.36L5.76 8.95001L8.59 11.78L18.59 1.78001L20 3.18001ZM17.79 8.22001C17.92 8.79001 18 9.39001 18 10C18 14.42 14.42 18 10 18C5.58 18 2 14.42 2 10C2 5.58001 5.58 2.00001 10 2.00001C11.58 2.00001 13.04 2.46001 14.28 3.25001L15.72 1.81001C14.0464 0.629559 12.048 -0.00282112 10 9.46103e-06C4.48 9.46103e-06 0 4.48001 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 8.81001 19.78 7.67001 19.4 6.61001L17.79 8.22001Z",
    fill: "url(#paint0_linear_19118_532)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19118_532",
    x1: -0.00031146,
    y1: 19.9999,
    x2: 19.9998,
    y2: -0.000233973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D6AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D7E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulCheckInCircle);
export default __webpack_public_path__ + "static/media/colorful-check-in-circle.eb0718ea80da5df9207812391424c8ef.svg";
export { ForwardRef as ReactComponent };